import React, { useState } from "react";
import {
  School,
  GraduationCap,
  ClipboardCheck,
  CalendarDays,
  CheckCircle2,
  XCircle,
  History,
  BrainCircuit,
  CalendarClock,
  Mic,
  Send,
  MessageSquare,
} from "lucide-react";
import Navbar from "../../components/PSTVue/Navbar2";

// Main App Component
export default function Parent() {
  return (
    <div>
     <Navbar/>
      <div className=" bg-white min-h-screen font-sans text-slate-800">
        <div className="container mx-auto p-4 sm:p-6 lg:p-8">
          <Header />
          <main className="mt-6">
            <StudentSummary />
            <div className="mt-6 grid grid-cols-1 lg:grid-cols-3 gap-6">
              <div className="lg:col-span-2">
                <AssignmentsHomework />
              </div>
              <div className="lg:col-span-1">
                <SchoolEvents />
              </div>
              <div className="lg:col-span-2">
                <AttendanceRecords />
              </div>
              <div className="lg:col-span-1">
                <TeacherCommunication />
              </div>
            </div>
          </main>
        </div>
      </div>
     
    </div>
  );
}

// Header Component
const Header = () => (
  <header className="flex items-center space-x-3">
    <div className="bg-blue-100 p-2 rounded-lg">
      <School className="w-6 h-6 text-blue-600" />
    </div>
    <div>
      <h1 className="text-2xl font-bold text-slate-900">Parent Portal</h1>
      <p className="text-sm text-slate-500">
        Stay connected with your child's education with PST
      </p>
    </div>
  </header>
);

// Student Summary Card
const StudentSummary = () => {
  const student = {
    name: "Alex Smith",
    grade: "Grade 9",
    gpa: 3.8,
    attendance: 95,
    assignments: { completed: 45, total: 50 },
    predictedGpa: { value: 3.9, change: "+0.10" },
    assignmentCompletion: 90,
    attendanceRate: 95,
  };

  return (
    <div className="bg-slate-50 p-6 rounded-xl shadow-sm border border-slate-200 transition-shadow duration-300 hover:shadow-lg cursor-pointer">
    
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between">
        <div className="flex items-center space-x-4">
          <div className="bg-blue-500 p-3 rounded-full">
            <GraduationCap className="w-8 h-8 text-white" />
          </div>
          <div>
            <h2 className="text-xl font-bold text-slate-900">{student.name}</h2>
            <p className="text-sm text-slate-500">
              {student.grade} •{" "}
              <span className="text-green-600 font-semibold">
                {student.gpa.toFixed(2)} GPA
              </span>
            </p>
          </div>
        </div>
        <div className="grid grid-cols-3 gap-4 mt-4 sm:mt-0 w-full sm:w-auto">
          <div className="text-center">
            <p className="text-xs text-slate-500">Attendance</p>
            <p className="font-bold text-lg">{student.attendance}%</p>
          </div>
          <div className="text-center">
            <p className="text-xs text-slate-500">Assignments</p>
            <p className="font-bold text-lg">
              {student.assignments.completed}/{student.assignments.total}
            </p>
          </div>
          <div className="text-center">
            <p className="text-xs text-slate-500">Predicted GPA</p>
            <p className="font-bold text-lg text-blue-600">
              {student.predictedGpa.value.toFixed(2)}
            </p>
          </div>
        </div>
      </div>
      <div className="mt-6 space-y-4">
        <div>
          <div className="flex justify-between text-sm mb-1">
            <span className="font-medium">Assignment Completion</span>
            <span className="font-semibold">
              {student.assignmentCompletion}%
            </span>
          </div>
          <div className="w-full bg-slate-200 rounded-full h-2">
            <div
              className="bg-blue-600 h-2 rounded-full"
              style={{ width: `${student.assignmentCompletion}%` }}
            ></div>
          </div>
        </div>
        <div>
          <div className="flex justify-between text-sm mb-1">
            <span className="font-medium">Attendance Rate</span>
            <span className="font-semibold">{student.attendanceRate}%</span>
          </div>
          <div className="w-full bg-slate-200 rounded-full h-2">
            <div
              className="bg-green-500 h-2 rounded-full"
              style={{ width: `${student.attendanceRate}%` }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Assignments & Homework Card
const AssignmentsHomework = () => {
  const assignments = [
    {
      icon: BrainCircuit,
      title: "Math Quiz: Quadratic Equations",
      subject: "Mathematics",
      dueDate: "Aug 3, 2025",
      status: null,
    },
    {
      icon: History,
      title: "History Essay: World War II",
      subject: "History",
      dueDate: "Jul 31, 2025",
      status: 92,
    },
    {
      icon: Mic,
      title: "Science Lab Report",
      subject: "Science",
      dueDate: "Jul 29, 2025",
      status: 88,
    },
  ];

  return (
    <div className="bg-slate-50 p-6 rounded-xl shadow-sm h-full border border-slate-200 transition-shadow duration-300 hover:shadow-lg">
      <div className="flex items-center space-x-3">
        <ClipboardCheck className="w-6 h-6 text-blue-600" />
        <h3 className="text-lg font-bold">Assignments & Homework</h3>
      </div>
      <div className="mt-4 space-y-2">
        {assignments.map((item, index) => (
          <div
            key={index}
            className="flex items-center space-x-4 p-2 rounded-lg transition-colors duration-200 hover:bg-slate-50 cursor-pointer"
          >
            <div className="bg-slate-100 p-3 rounded-lg">
              <item.icon className="w-5 h-5 text-slate-500" />
            </div>
            <div className="flex-grow">
              <p className="font-semibold">{item.title}</p>
              <p className="text-xs text-slate-500">Due {item.dueDate}</p>
            </div>
            {item.status && (
              <div className="bg-green-100 text-green-700 text-sm font-bold px-3 py-1 rounded-full">
                {item.status}%
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

// School Events Card
const SchoolEvents = () => {
  const events = [
    {
      title: "Parent-Teacher Conference",
      desc: "Individual meetings with teachers to discuss student progress",
      date: "Aug 8, 11:58 AM",
      location: "School Auditorium",
      tag: "Parent-teacher",
      color: "orange",
    },
    {
      title: "Science Fair",
      desc: "Annual school science fair showcasing student projects",
      date: "Aug 11, 11:58 AM",
      location: "School Gymnasium",
      tag: "Academic",
      color: "blue",
    },
    {
      title: "Spring Break",
      desc: "School closed for spring break",
      date: "Aug 16, 11:58 AM",
      location: "",
      tag: "Holiday",
      color: "green",
    },
  ];

  const tagColors = {
    orange: "bg-orange-100 text-orange-700",
    blue: "bg-blue-100 text-blue-700",
    green: "bg-green-100 text-green-700",
  };

  return (
    <div className="bg-slate-50 p-6 rounded-xl shadow-sm h-full border border-slate-200 transition-shadow duration-300 hover:shadow-lg">
      <div className="flex items-center space-x-3">
        <CalendarClock className="w-6 h-6 text-orange-500" />
        <h3 className="text-lg font-bold">School Events</h3>
      </div>
      <div className="mt-4 space-y-2">
        {events.map((event, index) => (
          <div
            key={index}
            className="relative pl-6 p-2 rounded-lg transition-colors duration-200 hover:bg-slate-50 cursor-pointer"
          >
            <div className="absolute left-2 top-1/2 -translate-y-1/2 w-3 h-3 bg-white border-2 border-orange-400 rounded-full"></div>
            {index < events.length - 1 && (
              <div className="absolute left-[9px] top-[calc(50%+0.5rem)] w-0.5 h-full bg-orange-200"></div>
            )}
            <div className="flex justify-between items-start">
              <h4 className="font-semibold">{event.title}</h4>
              <span
                className={`text-xs font-semibold px-2 py-0.5 rounded-full ${
                  tagColors[event.color]
                }`}
              >
                {event.tag}
              </span>
            </div>
            <p className="text-sm text-slate-500 mt-1">{event.desc}</p>
            <p className="text-xs text-slate-400 mt-1">
              {event.date}
              {event.location && ` • ${event.location}`}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

// Attendance Records Card
const AttendanceRecords = () => {
  const records = [
    { date: "August 1, 2025", day: "Friday", status: "present" },
    { date: "July 31, 2025", day: "Thursday", status: "present" },
    {
      date: "July 30, 2025",
      day: "Wednesday",
      status: "present",
      note: "Doctor Appointment",
    },
    { date: "July 29, 2025", day: "Tuesday", status: "present" },
    { date: "July 28, 2025", day: "Monday", status: "present" },
    { date: "July 27, 2025", day: "Sunday", status: "present" },
    { date: "July 26, 2025", day: "Saturday", status: "present" },
    { date: "July 25, 2025", day: "Friday", status: "absent" },
    { date: "July 24, 2025", day: "Thursday", status: "present" },
    { date: "July 23, 2025", day: "Wednesday", status: "present" },
  ];

  return (
    <div className="bg-slate-50 p-6 rounded-xl shadow-sm h-full border border-slate-200 transition-shadow duration-300 hover:shadow-lg">
      <div className="flex justify-between items-center">
        <div className="flex items-center space-x-3">
          <CalendarDays className="w-6 h-6 text-green-500" />
          <h3 className="text-lg font-bold">Attendance Records</h3>
        </div>
        <span className="text-sm font-semibold text-slate-600">
          90%{" "}
          <span className="text-slate-400 font-normal">attendance rate</span>
        </span>
      </div>
      <div className="mt-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
        {records.map((record, index) => (
          <div
            key={index}
            className={`p-3 rounded-lg text-center relative ${
              record.note ? "bg-yellow-50 border-yellow-200" : "bg-slate-50"
            } border transform transition-all duration-300 hover:scale-105 hover:shadow-md cursor-pointer`}
          >
            <p className="text-sm font-semibold">{record.date.split(",")[0]}</p>
            <p className="text-xs text-slate-500">{record.day}</p>
            <div
              className={`absolute top-2 right-2 w-5 h-5 flex items-center justify-center rounded-full ${
                record.status === "present" ? "bg-green-500" : "bg-red-500"
              }`}
            >
              {record.status === "present" ? (
                <CheckCircle2 className="w-3 h-3 text-white" />
              ) : (
                <XCircle className="w-3 h-3 text-white" />
              )}
            </div>
            {record.note && (
              <p className="text-xs text-yellow-700 mt-2 font-medium">
                {record.note}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

// Teacher Communication Card
const TeacherCommunication = () => {
  const teachers = [
    { name: "John Davis", subject: "Mathematics" },
    { name: "Sarah Wilson", subject: "Science" },
    { name: "Michael Brown", subject: "History", active: true },
  ];
  const [message, setMessage] = useState("");

  return (
    <div className="bg-slate-50 p-6 rounded-xl shadow-sm h-full border border-slate-200 flex flex-col transition-shadow duration-300 hover:shadow-lg">
      <div className="flex items-center space-x-3">
        <MessageSquare className="w-6 h-6 text-purple-500" />
        <h3 className="text-lg font-bold">Teacher Communication</h3>
      </div>
      <div className="mt-4">
        <p className="text-sm font-semibold mb-2">Teachers</p>
        <div className="space-y-2">
          {teachers.map((teacher, index) => (
            <div
              key={index}
              className={`p-3 rounded-lg flex items-center space-x-3 ${
                teacher.active
                  ? "bg-purple-100 border-purple-200 hover:bg-purple-200"
                  : "bg-slate-100 border-transparent hover:bg-slate-200"
              } border transition-colors duration-200 cursor-pointer`}
            >
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center ${
                  teacher.active ? "bg-purple-500" : "bg-slate-400"
                }`}
              >
                <span className="text-white font-bold text-sm">
                  {teacher.name.charAt(0)}
                </span>
              </div>
              <div>
                <p
                  className={`font-semibold text-sm ${
                    teacher.active ? "text-purple-800" : "text-slate-800"
                  }`}
                >
                  {teacher.name}
                </p>
                <p className="text-xs text-slate-500">{teacher.subject}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="mt-auto pt-4">
        <div className="relative">
          <input
            type="text"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Type your message..."
            className="w-full bg-slate-100 rounded-lg py-3 pl-4 pr-12 text-sm focus:outline-none focus:ring-2 focus:ring-purple-400"
          />
          <button className="absolute right-2 top-1/2 -translate-y-1/2 bg-purple-500 text-white p-2 rounded-md hover:bg-purple-600 transition-colors active:scale-95">
            <Send className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};